export class PermissionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PermissionError';

    Object.setPrototypeOf(this, PermissionError.prototype);
  }
}
